// import * as Routes from '../constants/routes';
// // import { trackingEvent } from '../helpers/tracking';

// import Intro from '../calculators/pay-yourself-first/containers/intro';
import PayYourselfFirst from '../calculators/financial-planning/containers/pay-yourself-first';
import PayDownDebtOrInvest from '../calculators/financial-planning/containers/pay-down-debt-or-invest';
import LoanPayment from '../calculators/financial-planning/containers/loan-payment';
import MortgagePayment from '../calculators/financial-planning/containers/mortgage-payment';
import NetWorth from '../calculators/financial-planning/containers/net-worth';
import SavingsGoal from '../calculators/financial-planning/containers/savings-goal';

export const name = 'Financial Planning';

export const inSecondaryMenu = true;

export const routes = [
    // {
    //     path: Routes.HOME,
    //     component: Intro,
    //     pagination: false,
    //     progressBar: false
    // },
    {
        path: '/pay-yourself-first',
        name: 'Pay Yourself First',
        component: PayYourselfFirst,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/pay-debt-invest',
        name: 'Pay Down Debt or Invest',
        component: PayDownDebtOrInvest,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/mortgage-payment',
        name: 'Mortgage Payment',
        component: MortgagePayment,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/loan-payment',
        name: 'Loan Payment',
        component: LoanPayment,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/net-worth',
        name: 'Net Worth',
        component: NetWorth,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/savings-goal',
        name: 'Savings to Reach Goal',
        component: SavingsGoal,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    }
];
